export const initFooterYear = () => {
  const year = String(new Date().getFullYear());

  document.querySelectorAll('.footer__rights--year').forEach((element) => {
    element.textContent = year;
  });
};
